import { Fragment, ReactNode } from "react";
export type IRenderImg = {
  src?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
};
export const RenderImg = (props: IRenderImg): ReactNode => {
  const { src = "", alt = "", width = 50, height = 50 } = props;

  return (
    <Fragment>
      <img src={src} alt={alt} width={width} height={height} />
    </Fragment>
  );
};
